<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <v-card class="modal-container betSlipContainer" :color="$vuetify.theme.dark ? '#232D3F' : ''">
          <v-btn elevation="0" v-if="!loadCircle" fab color="error" small class="modal-default-button title"
            style="position:absolute;" @click="$emit('close'), cancelChecking()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <h2 class="mt-4 betSlipItemName">{{ item.tabNo }}. {{ item.name }}</h2>
          <h4 class="betSlipRaceName">{{ race.name }}</h4>
          <div style="margin:0 auto;text-align:center">
            <h2 class="betSlipItemName d-inline" v-if="bet === 'COMBO'">w: ${{ this.W }} p: ${{ this.P }} <span v-if="this.S">
                s: ${{ this.S }}</span></h2>
            <h1 class="betRunnerPrice d-inline" v-else>${{ price }}</h1>
            <h3 v-if="bet !== 'COMBO'" class="betSlipType d-inline ml-2">{{ bet }}</h3>
          </div>
          <div v-if="betLimitMax || betLimitMin" style="margin:0 auto;text-align:center">
            <h3 class="warning--text d-inline ml-2">Bet Limits enforced Min: ${{ betLimitMin }} | Max: ${{ betLimitMax }}
            </h3>
          </div>
          <div class="d-flex justify-center align-center" v-if="bet === 'COMBO'">
            <v-checkbox disabled v-model="wpSelected"></v-checkbox>
            <v-btn elevation="0" :disabled="!placePrice" class="white--text mr-8 title" large width="90"
              color="blue-grey lighten-1" @click="selectWp()">WP</v-btn>
            <v-checkbox disabled v-model="wpsSelected" v-if="showPrice"></v-checkbox>
            <v-btn elevation="0" large :disabled="!showPrice" v-if="showPrice" class="white--text title" width="90"
              color="lime darken-2" @click="selectWps()">WPS</v-btn>
          </div>
          <v-card color="#232D3F" class="mx-5">

            <div>
              <div v-if="!highDomKeyboard" class="row" slot="body" style="float:left;width:500px;">
                <v-switch v-model="keypad" label="Keypad"></v-switch>
                <div class="col-12">
                  <div v-if="keypad" style="width:60%;margin:0 auto;">
                    <SimpleKeyboardAMT @onChange="onChange" :input="stake" />
                  </div>
                  <div v-if="!keypad" class="row">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(1)">$1</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(2)">$2</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(5)">$5</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(10)">$10</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(20)">$20</v-btn>
                  </div>
                </div>
                <div v-if="!keypad" class="col-12">
                  <div class="row">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(50)">$50</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(100)">$100</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(200)">$200</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(500)">$500</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 white--text headline font-weight-bold" width="60"
                      color="red" @click="stake = 0">Clear</v-btn>
                  </div>
                </div>
              </div>
              <div v-if="highDomKeyboard" class="row" slot="body" style="float:left;width:500px;">
                <v-switch v-model="keypad" label="Keypad"></v-switch>
                <div class="col-12">
                  <div v-if="keypad" style="width:60%;margin:0 auto;" class="mt-n10">
                    <SimpleKeyboardAMT @onChange="onChange" :input="stake" />
                  </div>
                  <div v-if="!keypad" class="row ml-10">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(100)">$100</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(200)">$200</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(500)">$500</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(1000)">$1000</v-btn>
                  </div>
                </div>
                <div v-if="!keypad" class="col-12">
                  <div class="row ml-10">
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(2000)">$2000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(5000)">$5000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 headline font-weight-bold" width="60"
                      @click="addStake(10000)">$10000</v-btn>
                    <v-btn elevation="0" x-large class="d-inline ma-1 white--text headline font-weight-bold" width="60"
                      color="red" @click="stake = 0">Clear</v-btn>
                  </div>
                </div>
              </div>
              <v-text-field type="number" autofocus pattern="[0-9]*" v-model="stake" placeholder="0"
                :label="ticketStatusName('Stake')" style="width:150px;" outlined
                class="float-left mt-5 mb-n15 display-1"></v-text-field>
              <v-text-field type="number" pattern="[0-9]*" v-model="profit" disabled label="Potential Return"
                style="width:150px;" outlined class="float-right mt-5 mb-n15 display-1"></v-text-field>
            </div>
          </v-card>
          <!-- <v-text-field type="number" pattern="[0-9]*" :value="stake" label="Stake" style="width:170px;" outlined class="float-left mt-5 display-1"></v-text-field> -->

          <!-- <div class="unitStake">
          <div style="float:left;">Stake Amount</div>
          <div class="betStake" style="float:right;">${{confirmedStake}}</div>
        </div> -->
          <!-- <div class="possiblePayout payoutTxt">Possible Payout: $<strong>{{price}}</strong></div> -->
          <v-btn elevation="0" v-if="!betLimitError && !checkModalTypeState()" x-large class="placeBetButton"
            @click="addBet()" color="success" :disabled="loadCircle || checkZeroAmout">
            <span class="display-1">Add to Slip</span>
          </v-btn>
          <v-btn elevation="0" v-if="!betLimitError && checkModalTypeState()" x-large class="placeBetButton" disabled>
            <span class="display-1">No Bet Type Chosen</span>
          </v-btn>
          <v-btn elevation="0" v-if="betLimitError" x-large class="placeBetButton" @click="stake = 0, betLimitError = false"
            color="error">
            <span class="display-1">Bet Limit Reached!</span>
          </v-btn>
        </v-card>
      </div>
    </div>
  </transition>

  <!-- app -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import SimpleKeyboardAMT from "./SimpleKeyboardAMT"
import { nanoid } from 'nanoid'
import { NAMINGS, HIGHKEYBOARD, PRICE_DISPLAY } from '../common/constants'
import { updateCustomerDisplayPendingBet } from '../common/customerDisplay'
import axios from 'axios'
import { Auth } from 'aws-amplify'

export default {
  name: 'BetStakeModal',
  data() {
    return {
      stake: null,
      interval: {},
      value: 0,
      loadCircle: false,
      error: null,
      betStatus: null,
      betId: null,
      checkBetPoll: null,
      keypad: false,
      betLimitMin: '',
      betLimitMax: '',
      betLimitError: false,
      wpSelected: false,
      wpsSelected: false,
      bets: []
    }
  },
  components: {
    SimpleKeyboardAMT
  },
  props: {
    item: Object,
    bet: String,
    race: Object,
    price: Number,
    betCode: String,
    clearStake: Function,
    rejectedTicket: Function,
    placePrice: Number,
    showPrice: Number,
    W: Number,
    P: Number,
    S: Number
  },
  computed: {
    ...mapGetters(['getTerminalId', 'getVenueName']),
    profit: function () {
      if (this.bet === 'COMBO' && this.wpSelected) {
        const actualStake = this.stake / 2
        const placeReturn = this.P * actualStake
        const winReturn = this.W * actualStake
        return this.potentialReturn(placeReturn + winReturn)
      }
      if (this.bet === 'COMBO' && this.wpsSelected) {
        const actualStake = this.stake / 3
        const showReturn = this.S * actualStake
        const placeReturn = this.P * actualStake
        const winReturn = this.W * actualStake
        return placeReturn + winReturn + showReturn
      }
      return this.potentialReturn(this.price * this.stake)
    },
    highDomKeyboard() {
      if (HIGHKEYBOARD[this.getVenueName]) return true
      return false
    },
    checkZeroAmout() {
      if (this.stake === '0' || this.stake === null || this.stake === 0) return true
      return false
    }
  },
  beforeDestroy() {
    clearInterval(this.checkBetPoll)
    updateCustomerDisplayPendingBet({
      bet: "",
      cost: "",
      payout: "",
      bi: "",
      runnerName: "",
    });
  },
  mounted() {
    this.updateCustomerDisplay();
    // this.checkConfig()
  },
  methods: {
    ...mapActions(['showBetModal', 'loadBets', 'updateScannedTickets']),
    potentialReturn(v) {
      return (Math.floor(v * 100).toFixed(0) / 100).toFixed(2)
    },
    checkModalTypeState() {
      const combo = (this.bet === 'COMBO' && !this.wpSelected && !this.wpsSelected)
      if (combo) return true
      return false
    },
    betTypeNormal() {
      const display = PRICE_DISPLAY
      const v = this.betCode
      const type = display.find(c => c.display === v && c.venueName === this.getVenueName)?.apiName
      return type
    },
    betType(v) {
      const display = PRICE_DISPLAY
      // const v = this.betCode
      const type = display.find(c => c.display === v && c.venueName === this.getVenueName)?.apiName
      return type
    },
    async addBet() {
      this.loadCircle = true,
        this.interval = setInterval(() => {
          if (this.value === 100) {
            return (this.value = 0)
          }
          this.value += 10
        }, 1000)
      const newBet = {
        runnerName: this.item.name,
        runnerNumber: this.item.tabNo,
        raceName: this.race.name,
        selId: this.item.selectionID,
        trackName: this.race?.meeting?.track?.name,
        trackCountry: this.race?.meeting?.track?.country,
        trackNumber: this.race?.number,
        startTime: this.race?.startTime,
        meeting: this.race?.meeting,
        raceId: this.race?.id,
      }

      const a = ['W', 'P']
      const t = ['W', 'P', 'S']
      if (this.wpSelected) {
        a.forEach(b => {
          const completeBet = {}
          completeBet.key = nanoid()
          completeBet.winPlc = this.betType(b)
          completeBet.odds = this[b]
          completeBet.stake = Number(this.stake / 2)?.toFixed(2)
          const finalBet = { ...newBet, ...completeBet }
          this.loadBets(finalBet)
        })
      } else if (this.wpsSelected) {
        t.forEach(z => {
          const completeBet = {}
          completeBet.key = nanoid()
          completeBet.winPlc = this.betType(z)
          completeBet.stake = Number(this.stake / 3)?.toFixed(2)
          completeBet.odds = this[z]
          const finalBet = { ...newBet, ...completeBet }
          this.loadBets(finalBet)
        })
      } else {
        this.loadBets({
          runnerName: this.item.name,
          runnerNumber: this.item.tabNo,
          raceName: this.race.name,
          winPlc: this.betTypeNormal(),
          selId: this.item.selectionID,
          odds: this.price,
          stake: Number(this.stake)?.toFixed(2),
          trackName: this.race?.meeting?.track?.name,
          trackCountry: this.race?.meeting?.track?.country,
          trackNumber: this.race?.number,
          startTime: this.race?.startTime,
          meeting: this.race?.meeting,
          raceId: this.race?.id,
          key: nanoid()
        })
      }

      this.$emit('close');
      this.clearStake(this.betStatus, this.betId, this.error),
        this.loadCircle = false
    },
    selectWp() {
      this.wpSelected = true,
        this.wpsSelected = false
    },
    selectWps() {
      this.wpsSelected = true,
        this.wpSelected = false
    },
    addStake(amt) {
      if (this.bet === 'COMBO' && this.wpSelected) {
        this.stake = (parseFloat(this.stake || 0) + parseFloat(amt) * 1).toString()
      }
      if (this.bet === 'COMBO' && this.wpsSelected) {
        this.stake = (parseFloat(this.stake || 0) + parseFloat(amt) * 2).toString()
      }
      this.stake = (parseFloat(this.stake || 0) + parseFloat(amt)).toString()
    },
    onChange(enteredAmt) {
      this.stake = enteredAmt
    },
    processThisTicket(v) {
      if (!window.processTicket) {
        window.processTicket = console.log
      }
      window.processTicket(JSON.stringify(v))
    },
    //start temporary poll checking cancel on exit of betslip modal
    cancelChecking() {
      this.cancelCheckBetPolling()
      this.clearStake('cancelled', 'Operator Cancelled', this.betId, this.error, this.refundBet, this.ticketId)
    },
    // end temporary poll checking cancel on exit of betslip modal
    cancelCheckBetPolling() {
      clearInterval(this.checkBetPoll)
      this.checkBetPoll = null
    },
    ticketStatusName(v) {
      const name = NAMINGS
      const status = name.find(c => c.word === v && c.venueName === this.getVenueName)?.replaceWith
      return status || v
    },
    updateCustomerDisplay() {
      const ci = {
        bet: this.bet,
        cost: this.stake ? `$${this.stake}` : "",
        payout: `Potential Payout: $${this.profit}`,
        bi: this.item.tabNo,
        runnerName: this.item.name,
      };
      updateCustomerDisplayPendingBet(ci);
    },
    async checkConfig() {
      const data = await Auth?.currentSession()
      try {
        axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetVenueByTerminalId`, {
          terminalId: this.getTerminalId,
        },
          {
            headers: {
              Authorization: 'Bearer ' + data.accessToken.jwtToken,
            },
            credentials: true
          }).then(response => {
            const config = response.data.venue.venueConfiguration
            const configParse = JSON.parse(config)
            this.betLimitMax = configParse.BetMax
            this.betLimitMin = configParse.BetMin
          })
      } catch (error) {
        console.log('error:');
        console.log(error)
      }
    }
  },
  watch: {
    stake() {
      this.updateCustomerDisplay();
      // if (this.betLimitMin || this.betLimitMax) {
      //   if ((this.stake <= this.betLimitMax) || (this.stake >= this.betLimitMin)) {
      //     this.betLimitError = false
      //   } if ((this.stake >= this.betLimitMax) || (this.stake <= this.betLimitMin)) {
      //     this.betLimitError = true
      //   }
      // }
    },
    wpSelected() {
      if (this.bet === 'COMBO' && this.wpSelected) {
        const newAmt = this.stake / 2
        const amt = newAmt * 1
        this.stake = (parseFloat(amt).toString())
      }
    },
    wpsSelected() {
      if (this.bet === 'COMBO' && this.wpsSelected) {
        const newAmt = this.stake / 3
        this.stake = (parseFloat(this.stake || 0) + parseFloat(newAmt)).toString()
      }
    }
  }
}
</script>

<style>
.betSlipType {
  text-align: center;
  font-weight: 600;
  color: #00A500
}

.betRunnerPrice {
  text-align: center;
  font-size: 3em;
}

.placeBetButton {
  border-radius: 8px;
  width: 100%;
  padding: 12px;
  color: #fff;
  font-size: 1.8em;
  text-align: center;
  bottom: -50px;
  z-index: 200;
  position: relative;
  font-weight: 600;
  cursor: pointer;
}

.payoutTxt {
  float: right;
  font-size: 1.1em;
  margin-top: 5px;
}

.betSlipSpacer {
  height: 130px;
  background: #fff;
  width: 100%;
  margin-bottom: 30px;
  border-top: 1px solid #efefef;
  padding-top: 10px;
}

.betSlipItemName {
  text-align: center;
  font-size: 2.0em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.betSlipRaceName {
  text-align: center;
  font-weight: 600;
}

.spacerContainer {
  height: 40px;
  padding-top: 10px;
}

.addMultiButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  font-size: 1.1em;
  color: #333;
  width: 100%;
  padding: 10px;
  margin-top: 50px;
  text-align: center;
}

.unitStake {
  border: 1px solid #666;
  width: 100%;
  padding: 5px;
  font-size: 1.2em;
  font-weight: 500;
  background: #e6faff;
  color: #666;
  height: 1.8em;
  margin-top: 50px;
}

.betPriceButton {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 1em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
  cursor: pointer;
}

.removeBorder {
  box-shadow: none;
  background-color: #ffffff;
  height: 3em;
  width: 18%;
  padding: 5px;
  text-align: center;
  margin: 5px 0 0 5px;
}

.modal-icon {
  margin-top: -80px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.betSlipContainer {
  width: 580px;
  margin: 0px auto;
  padding: 20px 30px;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.betPriceButtonClear {
  background-color: #ffffff;
  height: 3em;
  width: 17%;
  font-size: 0.9em;
  padding: 5px;
  text-align: center;
  margin: 7px 0 0 7px;
  line-height: 2.5em;
  font-weight: 600;
  color: #333;
}

@media only screen and (max-width: 600px) {
  .modal-container {
    width: 90%;
    margin: 0px auto;
    padding: 20px 30px;
    border-radius: 10px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .betPriceButton {
    box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.5);
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.8em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .betPriceButtonClear {
    background-color: #ffffff;
    height: 3em;
    width: 17%;
    font-size: 0.7em;
    padding: 5px;
    text-align: center;
    margin: 7px 0 0 7px;
    line-height: 2.5em;
    font-weight: 600;
    color: #333;
  }

  .modal-default-button {
    display: inline-block;
  }

  .raceTypeIconSlip {
    height: 80px;
    width: 80px;
    border-radius: 80px;
    background: #fff;
    margin: 0 auto;
    top: -80px;
    z-index: 200;
    position: relative;
    border: 6px solid #000;
    text-align: center;
  }
}

.raceTypeIconSlip {
  height: 80px;
  width: 80px;
  border-radius: 80px;
  background: #fff;
  margin: 0 auto;
  top: -60px;
  z-index: 200;
  position: relative;
  border: 6px solid #000;
  text-align: center;
}

.modal-default-button {
  float: left;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}</style>
